<template>
  <a :href="match.slug" :title="match.title">
    <div
      class="as-match-item"
      :class="{
        'as-is-hot': match.is_hot,
        'as-hide-footer': !isShowFooter,
        'as-match-item-sm': screenWidth < 360,
        [`as-match-item-${siteName}`]: siteName,
      }"
    >
      <div class="as-match-item__header">
        <div class="as-match-item__league">
          <img
            v-if="competition"
            class="as-lazy"
            :src="getImgUrlBySport('competition', match.competition_id)"
            :alt="
              competition.short_name ? competition.short_name : competition.name
            "
            width="24px"
            height="24px"
          />
          <span v-if="competition">{{ getCompetitionShortCode(competition, isMobile) }}</span>
        </div>
        <div class="as-match-item__time as-match-item__status--normal">
          <div
            v-if="
              (isH2h ||
                MatchEnum.LIST_STATUS_PLAYING.includes(match.status_id)) &&
              match?.match_time_player
            "
            @mouseover="handleMouseStatisticOver"
            @mouseleave="handleMouseLeave"
            :class="`as-icon-haflt ${
              match?.match_time_player.status_h2h
                ? 'as-icon-haflt-' + match?.match_time_player.status_h2h
                : ''
            }`"
          >
            <span class="as-t_time_num">
              {{ match?.match_time_player?.text }}
            </span>
            <ProgressBar :match="match" />
          </div>
        </div>
        <div class="as-match-item__date">
          {{ formatLocalTime(match.match_time, "h:mm DD/MM") }}
        </div>
      </div>
      <div class="as-match-item__body">
        <a
          :href="getLinkTeamDetail(match.home_team_id, getTeamName(teams, match.home_team_id))"
          class="as-match-item__team as-match-item__team-home as-team--home"
        >
          <img
            :src="getImgUrlBySport('team', match.home_team_id)"
            :alt="getTeamName(teams, match.home_team_id)"
            class="as-match-item__team-logo as-match-item__team-away-logo as-team__logo as-lazy"
          />
          <span
            class="as-match-item__team--name as-match-item__team--home-name"
            >{{ getTeamName(teams, match.home_team_id) }}</span
          >
        </a>
        <div
          v-if="match.status_id === MatchEnum.STATUS_NOT_STARTED"
          class="as-scoreboard"
        >
          <span :class="`as-score-vs as-score-vs__28 as-score-vs__only-text as-score-vs__only-text-${siteName}`"
            >vs</span
          >
        </div>
        <div
          v-else
          @mouseover="handleMouseOver"
          @mouseleave="handleMouseLeave"
          class="as-match-item__status"
        >
          <ScoreVs :match="match" :size="28" />
        </div>

        <a
          :href="getLinkTeamDetail(match.away_team_id, getTeamName(teams, match.away_team_id))"
          class="as-match-item__team as-match-item__team-away as-team--away"
        >
          <img
            :src="getImgUrlBySport('team', match.away_team_id)"
            :alt="getTeamName(teams, match.away_team_id)"
            class="as-match-item__team-logo as-match-item__team-away-logo as-team__logo as-lazy"
          />
          <span
            class="as-match-item__team--name as-match-item__team--away-name"
            >{{ getTeamName(teams, match.away_team_id) }}</span
          >
        </a>
      </div>
      <div v-if="isShowFooter"
        class="as-match-item__footer"
        :class="{
          'as-match-item__footer-show-all': isShouldFooterFlag && isShouldFooterCommentator,
        }"
      >
        <div
          v-if="isShouldFooterFlag"
          class="as-flag as-d-flex"
        >
          <div class="as-flag__goal-scoring as-d-flex">
            <span>HT</span>
            <span class="as-flag__half-court"
              >{{ homeScores[1] }} - {{ awayScores[1] }}</span
            >
          </div>
          <div class="as-flag__corner-ball as-d-flex">
            <IconCornerNew fill_top="#5EB24A" fill_bottom="#FFB400" />
            <span class="as-flag__corner-goal">
              {{ homeScores[4] }} - {{ awayScores[4] }}
            </span>
          </div>
          <div class="as-flag__yellow-card as-d-flex">
            <IconYellowCard />
            <span class="as-flag__yellow-goal">
              {{ homeScores[3] }} - {{ awayScores[3] }}
            </span>
          </div>
        </div>
        <div v-if="isShouldFooterCommentator" class="as-commentator">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <path
              d="M15.2328 2.96681L19.5921 6.134C21.5198 7.53454 22.3264 10.0171 21.5901 12.2832L19.925 17.4078C19.1887 19.6739 17.0769 21.2082 14.6942 21.2082H9.30583C6.92309 21.2082 4.81133 19.6739 4.07502 17.4078L2.40993 12.2832C1.67363 10.0171 2.48025 7.53454 4.40793 6.134L8.76718 2.96682C10.6949 1.56627 13.3051 1.56627 15.2328 2.96681Z"
              :fill="'url(#pattern_' + match.id + ')'"
              stroke="#FFC107"
            ></path>
            <defs>
              <pattern
                :id="'pattern_' + match.id"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  :xlink:href="`#image__${match.id}_${match.commentator_id}`"
                  transform="scale(0.000510204)"
                ></use>
              </pattern>
              <image
                :id="`image__${match.id}_${match.commentator_id}`"
                width="1960"
                height="1960"
                :xlink:href="commentator ? commentator.avatar : ''"
              ></image>
            </defs>
          </svg>
          <span>{{ commentator ? commentator.name : "" }}</span>
        </div>
      </div>
    </div>
  </a>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import MatchEnum from "~src/enums/MatchEnum";
import OddItem from "~src/modules/home/components/OddItem.vue";
import ProgressBar from "~src/components/matches/ProgressBar.vue";
import type {
  IMatch,
  IOdd,
  ITeam,
  ILeague,
  ICommentator,
} from "~src/interfaces";
import ScoreVs from "~src/components/matches/ScoreVs.vue";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import { getTeamName } from "~src/helpers";
import { getOddValue } from "~src/helpers/OddHelper";
import { useMatchDetailStore } from "~src/stores/MatchDetailStore";
import IconCorner from "../icons/IconCorner.vue";
import IconCornerNew from "../icons/IconCornerNew.vue";
import IconYellowCard from "../icons/IconYellowCard.vue";
import { usecommonStore } from "~src/stores/CommonStore";
import { useIsMobile } from "~src/utils/isMobile";
const commonStore = usecommonStore();
const matchDetailStore = useMatchDetailStore();

interface IProps {
  match: IMatch;
  odds?: Array<IOdd>;
  oddsOld?: Array<IOdd>;
  teams: Array<ITeam>;
  commentators: Array<ICommentator>;
  competitions: Array<ILeague>;
  isShowFlagHalf: boolean;
  isShowFooter: boolean;
  isH2h: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  odds: () => [],
  oddsOld: () => [],
  isShowFlagHalf: true,
  isShowFooter: true,
  isH2h: false,
});

const siteName = computed(() => commonStore.getSiteName);
const screenWidth = computed(() => matchDetailStore.getScreenWidth);
const isMobile = ref(useIsMobile());

// footer value
const isShouldFooterFlag = computed(() => {
  return props.match.status_id != MatchEnum.STATUS_NOT_STARTED && props.isShowFlagHalf;
});

const isShouldFooterCommentator = computed(() => {
  return !!props.match.commentator_id;
});

const odd = computed(() => {
  return props.odds.find((item: IOdd) => item.id === props.match.id);
});

const oddOld = computed(() => {
  return props.oddsOld.find((item: IOdd) => item.id === props.match.id);
});

const isShowOdd = computed(() => {
  let check = false;
  for (const key of [
    "asian_hdp",
    "asian_hdp_home",
    "asian_hdp_away",
    "asian_close",
    "european_home",
    "european_draw",
    "european_away",
    "european_close",
    "over_under_hdp",
    "over",
    "under",
    "over_under_close",
  ] as Array<string>) {
    if (getOddValue(odd.value, oddOld.value, key).value != "") {
      check = true;
    }
    break;
  }

  return check;
});

const competition = computed(() => {
  const compet: any = props.competitions.find(
    (item: ILeague) => item.id === props.match.competition_id
  );

  return compet;
});

const commentator = computed(() => {
  const compet: any = props.commentators.find(
    (item: ICommentator) => item.id === props.match.commentator_id
  );

  return compet;
});

const homeScores = props.match.home_scores || [];
const awayScores = props.match.away_scores || [];

const homeScore = computed(() => {
  let score = props.match.home_scores[0];

  // Trường hợp đá hiệp phụ
  if (homeScores[5] > 0) {
    score = homeScores[5];

    return score;
  }

  return score;
});

const awayScore = computed(() => {
  let score = awayScores[0];

  // Trường hợp đá hiệp phụ
  if (awayScores[5] > 0) {
    score = awayScores[5];

    return score;
  }

  return score;
});
const activeIncident = ref(false);
const activeHoverPopup = ref(false);
const activeStatistic = ref("");
let hideTimeout: number | undefined = undefined;

const handleMouseOverPopup = async (event: MouseEvent) => {
  activeHoverPopup.value = true;
};

const handleMouseLeavePopup = async (event: MouseEvent) => {
  activeHoverPopup.value = false;
  activeIncident.value = false;
};

const handleMouseOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "";
};

const handleMouseLeave = () => {
  // Use a timeout to avoid flickering
  setTimeout(() => {
    if (!activeHoverPopup.value) {
      activeIncident.value = false;
    }
  }, 100); // Adjust delay as needed
};

const handleMouseStatisticOver = async (event: MouseEvent) => {
  // if (hideTimeout) {
  //   clearTimeout(hideTimeout);
  //   hideTimeout = undefined;
  // }
  activeIncident.value = true;
  activeStatistic.value = "statistic";
};
</script>

<script lang="ts">
export default {};
</script>
